import { useRouter } from "@tanstack/react-router";
import type { Client, FamilyDetail } from "creso-core/types";
import JSZip from "jszip";
import { CapitalGainsDialog as CapitalGainsDialogBase } from "web-core";

const createZip = () => new JSZip();

type CapitalGainsDialogProps =
  | { client: Client; family?: never }
  | { family: FamilyDetail; client?: never };

/**
 * Partners adapter for the shared capital gains dialog: owns the search-param
 * driven open/close and supplies the zip for the family download, so `jszip`
 * does not leak into web-core.
 */
export function CapitalGainsDialog(props: CapitalGainsDialogProps) {
  const router = useRouter();
  const { family } = props;

  const onOpenChange = (open: boolean) => {
    if (!open) router.history.back();
  };

  if (family) {
    return (
      <CapitalGainsDialogBase
        family={family}
        open
        onOpenChange={onOpenChange}
        createZip={createZip}
      />
    );
  }

  return (
    <CapitalGainsDialogBase
      client={props.client}
      open
      onOpenChange={onOpenChange}
      onImportHoldings={() =>
        router.navigate({
          to: ".",
          search: (prev) => ({ ...prev, modal: "import-holdings" }),
        })
      }
    />
  );
}
